<template>
  <section class="brief-card" aria-label="AI晨报">
    <div class="brief-card-head">
      <h2><app-icon name="spark" />AI 晨报</h2>
      <span v-if="brief" class="brief-state" :class="{ ready: brief.status === 'ready' }">{{ state }}</span>
    </div>
    <p v-if="loading && !brief" class="brief-card-placeholder"><span class="spinner" />正在读取复盘与今日安排</p>
    <div v-else-if="error" class="brief-card-error" role="status"><p>{{ error }}</p><button class="text-button" type="button" :disabled="loading" @click="load">{{ loading ? '正在读取' : '重试读取' }}</button></div>
    <template v-else-if="brief">
      <p class="brief-card-summary">{{ brief.analysis.summary.text || brief.message }}</p>
      <p class="brief-card-counts">{{ reviewPeriod }}跟进 <b>{{ value(brief.stats.followed_customers) }}</b> 位<span>·</span>当日安排 <b>{{ value(brief.plan.events_total) }}</b> 项</p>
      <ol v-if="brief.analysis.priorities.length" class="brief-card-priorities">
        <li v-for="item in brief.analysis.priorities.slice(0, 3)" :key="item.customer_id"><b>{{ item.customer_name }}</b><span>{{ item.stale ? '资料已有更新，先核对最新跟进' : item.goal }}</span></li>
      </ol>
      <p v-if="brief.status !== 'ready'" class="brief-card-note">{{ brief.message }}</p>
      <router-link class="brief-card-link" :to="{ path: '/daily-brief', query: { date: brief.date } }">查看{{ reviewTitle }}与今日安排<app-icon name="arrow" /></router-link>
    </template>
  </section>
</template>
<script>
import { normalizeBrief, briefValue, briefState, briefReviewPeriod, briefReviewTitle } from '../common/daily-brief'
export default {
  data() { return { brief: null, loading: false, error: '', requestId: 0 } },
  computed: {
    state() { return briefState(this.brief) },
    reviewPeriod() { return briefReviewPeriod(this.brief) },
    reviewTitle() { return briefReviewTitle(this.brief) }
  },
  mounted() { this.load() },
  watch: { '$store.state.customerRevision': 'load' },
  beforeDestroy() { this.requestId++ },
  methods: {
    value: briefValue,
    async load() {
      if (this.loading) return
      this.loading = true
      this.error = ''
      const requestId = ++this.requestId
      try {
        const data = normalizeBrief(await this.$api.post('/api/employee/daily-brief', {}))
        if (!this._isDestroyed && requestId === this.requestId) this.brief = data
      } catch (e) { if (!this._isDestroyed && requestId === this.requestId) this.error = e.message }
      finally { if (!this._isDestroyed && requestId === this.requestId) this.loading = false }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/daily-brief-card.vue